import { WasteShippingConfig } from "@/models"
import { HttpService } from "@/services/httpService"

export class ConfigService extends HttpService {
	constructor() {
		super("/api")
	}
	async getConfig(): Promise<WasteShippingConfig> {
		return await this.returning(WasteShippingConfig).get("config.json")
	}
}
